import React, { useState } from "react";
import StatementTableData from ".";
import { TableLoader } from "../../../commons";
import "../index.scss";
import { broadCloseIcon, broadOpenIcon } from "../../../../assets/images";
import { getData } from "../common";
import { currencySignAndNegativeValueAdjust } from "../../../../utils/commonFunctions";
import { getprocessedData } from "./helperFunctions";

export const tableHeader = [
  {
    label: "",
    value: "ledger_name",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "",
    value: "closing_amount",
    checked: true,
    defaultChecked: true,
  },
];

type AppProps = {
  data: any;
  total: number;
  currencySign: string | undefined;
  fetching: boolean;
  subHeader: string;
  endDate: string;
  finalRedirectLink: { pathname: string } | Function;
  isLedgerStatementPresent?: boolean;
  isStocksStatementPresent?: boolean;
  selectedBranchId?: number | null;
  branchName?: string;
};
const BalanceSheetTable = ({
  data,
  total,
  fetching,
  currencySign,
  subHeader,
  finalRedirectLink,
  endDate,
  isLedgerStatementPresent,
  isStocksStatementPresent,
  selectedBranchId,
  branchName,
}: AppProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const renderBody = () => {
    let finalData = getData(data)?.map((singleData: any, index: number) => {
      if (singleData?.closing_amount) {
        // for inventory, we need to process the data to remove the zero amounts
        const processedData = getprocessedData(subHeader, singleData);
        return (
          <StatementTableData
            endDate={endDate}
            singleData={processedData}
            subHeader={subHeader}
            count={1}
            index={index + 1}
            currencySign={currencySign}
            finalRedirectLink={finalRedirectLink}
            isLedgerStatementPresent={isLedgerStatementPresent}
            isStocksStatementPresent={isStocksStatementPresent}
            selectedBranchId={selectedBranchId}
            branchName={branchName}
          />
        );
      }
    });
    return finalData;
  };

  const renderFooter = () => {
    let finalData = tableHeader?.map((thead: any) => {
      if (thead?.value === "ledger_name") {
        return (
          <td
            style={{
              borderTop:
                subHeader === "CUSTOMER" || subHeader === "SUPPLIER" || data?.length == 0
                  ? "1px solid #bfcbe1"
                  : "none",
            }}
          >
            <p className={"reports-total"}>
              TOTAL {subHeader === "CASH & CASH EQUIVALENT" ? "PAYMENT" : subHeader}{" "}
              {subHeader === "CUSTOMER" || subHeader === "SUPPLIER" ? " AMOUNT" : ""}
            </p>
          </td>
        );
      }
      if (thead?.value === "closing_amount") {
        return (
          <td
            style={{
              borderTop:
                subHeader === "CUSTOMER" || subHeader === "SUPPLIER" || data?.length == 0
                  ? "1px solid #bfcbe1"
                  : "none",
            }}
          >
            <p className={"reports-total"}>
              {currencySignAndNegativeValueAdjust(currencySign, total ? total?.toFixed(2)?.toString() : "0")}
            </p>
          </td>
        );
      }
    });
    return finalData;
  };

  const renderHeader = () => {
    return (
      <th
        style={{
          backgroundColor: "#e8ecf0",
          border: "none",
          borderRadius: "0px",
          color: "#6e7491",
          fontWeight: 600,
          fontSize: "14px",
          width: "75%",
        }}
      >
        {subHeader === "CUSTOMER" || subHeader === "SUPPLIER" ? (
          <div onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? (
              <img
                width="30px"
                style={{ cursor: "pointer" }}
                alt="open"
                src={broadOpenIcon}
                className="accordion-arrow"
              />
            ) : (
              <img
                width="30px"
                style={{ cursor: "pointer" }}
                alt="close"
                src={broadCloseIcon}
                className="accordion-arrow"
              />
            )}
            {subHeader}
          </div>
        ) : (
          subHeader
        )}
      </th>
    );
  };

  return (
    <>
      {fetching ? (
        <TableLoader Rows={10} ColumnPerRow={8} />
      ) : (
        <div className="grouping">
          <table className="table table-bordered">
            <thead>
              {renderHeader()}
              <th style={{ backgroundColor: "#e8ecf0", border: "none", borderRadius: "0px" }}></th>
            </thead>
            {subHeader === "CUSTOMER" || subHeader === "SUPPLIER" ? (
              isOpen && <tbody>{renderBody()}</tbody>
            ) : (
              <tbody>{renderBody()}</tbody>
            )}
            <tfoot>{renderFooter()}</tfoot>
          </table>
        </div>
      )}
    </>
  );
};

export default BalanceSheetTable;
